module.exports = __webpack_public_path__ + "static/media/img007.6e383d37.jpg";